export class PagingDto {
    public limit?: number
    public offset?: number
    public order?: string[]
  }